import { Injectable } from '@angular/core'; import { ActivatedRoute } from '@angular/router'; import { DeployParams } from '../deployParams';
import { IBonusSettings } from '../models/settings/bonusSettings.interface';
import { SettingsProviderService } from './providers/settings.provider.service';
import { pipe, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModelMapperService } from './util/model.mapper.service';
import { StorageService } from './util/storage.service';
import { TicketManagerUserService } from '../ticket-manager/services/ticketManagerUser.service';
import { UserService } from './user.service';
import { AuthenticationService } from '../ticket-manager/services/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class BonusService {

  public bonussSettings: Array<IBonusSettings> = [];
  public playerBonussSettings: Array<IBonusSettings> = [];
  private subscription: Subscription = new Subscription();

  constructor(private route: ActivatedRoute, private settingsProvider: SettingsProviderService, private modelMapper: ModelMapperService, private storage: StorageService, private tmUserService: TicketManagerUserService, private userService: UserService, private authenticationService: AuthenticationService) {
    this.subscription.add(tmUserService.tmUserChangedSource$.subscribe(() => this.reloadSettings()));
    this.subscription.add(authenticationService.loggedAffiliateChangedSource$.subscribe(() => {
      if (this.storage.affiliate) {
        this.setPlayerBonus(this.storage.affiliate.affiliateId);
      }
    }));
    if (environment.localDeploy) {
      if (this.userService.user.userSBToken != null && this.userService.user.userSBToken && this.userService.user.userSBToken !== '') {
        this.setPlayerBonus(+this.userService.user.userName);
      }
      this.userService.userLoggedInOut$.subscribe(x => {
        if (true) {
          this.setPlayerBonus(+this.userService.user.userName);
        }
      });
    } else {
      this.route.queryParams.subscribe(params => {
        this.paramsChangedSetBonus(params);
      });
    }

    if (this.storage.affiliate) {
      this.setPlayerBonus(this.storage.affiliate.affiliateId);
    }

    this.bonussSettings = storage.bonus;

    this.getBonusSettings();
  }

  getBonusSettings() {
    if (this.bonussSettings.length === 0) {
      this.settingsProvider.getBonusSettings(this.tmUserService.user && this.tmUserService.user.loggedOffice ? this.tmUserService.user.loggedOffice.id : environment.betWebOfficeId).pipe(
        map(bs =>
          bs.map(b => this.modelMapper.mapBonusSettings(b))
        )
      ).subscribe(bonus => {
        this.bonussSettings = bonus;
        this.storage.bonus = this.bonussSettings;
      });
    }
  }

  public reloadSettings() {
    this.bonussSettings = [];
    this.playerBonussSettings = [];
    this.getBonusSettings();
  }

  paramsChangedSetBonus(params: any): any {
    const playerId = params.username ? params.username : null;

    if (playerId == null) {
      return;
    }

    this.setPlayerBonus(playerId);
  }

  setPlayerBonus(playerId: number) {
    this.playerBonussSettings = this.storage.getPlayerBonus(playerId);

    if (this.playerBonussSettings.length === 0) {
      if (playerId) {
        this.settingsProvider.getBonusSettingsForPlayer(playerId, this.storage.affiliate ? true : false).pipe(
          map(bs =>
            bs.map(b => this.modelMapper.mapBonusSettings(b))
          )
        ).subscribe(bonus => {
          this.playerBonussSettings = bonus;
          this.storage.setPlayerBonus(this.playerBonussSettings, playerId);
        });
      }
    }
  }
}
